<div class="qr-code-container">
    <canvas #canvas></canvas>
    @if(showLabel()) {
        <span class="p-text-secondary qr-code-label">{{ 'QR_CODE_LABEL' | translate }}</span>
    }
</div>
